import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Spin, Tooltip } from 'antd';
import { PluginBillingWrapper } from '../ExchangeBilling/style';
import { DEFAULT_PLUGIN_PREVIEW, ONE_TIME_ACTIVATION_PLUGIN, VERIFIED_BADGE } from '../../config/media';

const PluginSubscription = ({ renderBtn, item = true, invoice, invoiceData, pluginData, isPay = false, isBilling, discountPrice, selectedpluginDetail, setSelectedpluginDetail, updatedPlugin }) => {

    useEffect(() => {
        if (isBilling) {
            if (!Object.keys(pluginData).length || isPay) {
                const filteredData = updatedPlugin && updatedPlugin.filter((value) => value.name === (invoiceData && invoiceData.meta && invoiceData.meta.activation.name));
                setSelectedpluginDetail(filteredData);
            }
            else {
                setSelectedpluginDetail([pluginData]);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [updatedPlugin])
    
    return (
        updatedPlugin.length ?
            <PluginBillingWrapper>
                <div className={!item ? "plugin-wrapper" : "plugin-wrapper pl-2"}>
                    <div>
                        <div className='d-flex content-wrapper'>
                            <img className='kyc-plugin-icon' src={selectedpluginDetail && selectedpluginDetail[0] && selectedpluginDetail[0].icon
                                ? selectedpluginDetail[0].icon
                                : DEFAULT_PLUGIN_PREVIEW} alt='kyc-plugin-icon'></img>
                            <div className='content-details-wrapper'>
                                <div className='plugin-app-label'>PLUGIN APP</div>
                                <div className='plugin-name'>{selectedpluginDetail && selectedpluginDetail[0] && selectedpluginDetail[0].name}</div>
                                <div className='plugin-description'>{selectedpluginDetail && selectedpluginDetail[0] && selectedpluginDetail[0].bio}</div>
                                <div className='d-flex footer-content'>
                                    <Tooltip placement="rightBottom" title={`Verified plugin by ${selectedpluginDetail && selectedpluginDetail[0] && selectedpluginDetail[0].author}`}><img className='verify-badge-icon' src={VERIFIED_BADGE} alt='verify-badge-icon'></img></Tooltip>
                                    <div className='author-label'>{selectedpluginDetail && selectedpluginDetail[0] && selectedpluginDetail[0].author}</div>
                                    <div className='custom-div'>-</div>
                                    <img className='one-time-activation-icon' src={ONE_TIME_ACTIVATION_PLUGIN} alt='one-time-activation-icon'></img>
                                    <div className='payment-type-label'>{selectedpluginDetail && selectedpluginDetail[0] && selectedpluginDetail[0].payment_type}</div>
                                </div>
                            </div>
                            <div className='custom-divider'></div>
                            <div className='display-cost d-flex'>
                                {
                                    invoice && invoice.meta && invoice.meta.amount
                                        ? `Cost: ${invoice.meta.amount} ${invoice.meta.currency}`
                                        : discountPrice &&
                                            (Object.keys(discountPrice).length !== 0 || discountPrice.constructor !== Object)
                                            ? `Cost: $ ${discountPrice.amount} ${discountPrice.currency && discountPrice.currency.toUpperCase()}`
                                            : `Cost: $ ${selectedpluginDetail && selectedpluginDetail[0] && selectedpluginDetail[0].price} USDT`
                                }
                            </div>
                        </div>
                    </div>
                    {item ? <div className='plugin-btn-wrapper'>
                        {renderBtn()}
                    </div> : null}
                </div>
            </PluginBillingWrapper>
            :
            <Spin spinning={true}></Spin>
    );
}

const mapStateToProps = (store) => {
    return {
        isBilling: store.plugin.isBilling,
        pluginData: store.plugin.pluginData,
    }
}

export default connect(mapStateToProps)(PluginSubscription);
